import { request } from '@umijs/max';

export async function queryGoodsList(
  params?: any,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/goods', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

export async function queryGoodsById(
  id: any,
  options?: { [key: string]: any },
) {
  return request<any>(`/api/v1/goods/${id}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function addGoods(
  body: API.GoodsInfoVO,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/goods', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

export async function updateGoods(
  id: number | string,
  body: API.GoodsInfoVO,
  options?: { [key: string]: any },
) {
  return request<any>(`/api/v1/goods/${id}`, {
    method: 'PUT',
    data: body,
    ...(options || {}),
  });
}

export async function removeGoods(
  id: number,
  options?: { [key: string]: any },
) {
  return request<any>(`/api/v1/goods/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}
